import { NewsComplaintDto } from './news-complaint.dto';
import { NewsPostDto } from './news-post.dto';

export interface NewsComplaintsFindResponseDto extends NewsComplaintDto {
  post: NewsPostDto;
}
